import { createSlice } from '@reduxjs/toolkit';
import { ModelJson } from 'domains/pageModel/api/fetch-model.types';
import { fetchModel } from './actions';

interface ModelState {
  model: ModelJson | null;
  loading: boolean;
  error: Error | null;
  loaded: boolean;
  customerId: string | null;
}

const initialState = {
  model: null,
  loading: false,
  loaded: false,
  error: null,
  customerId: null,
} as ModelState;

export const pageModelSlice = createSlice({
  name: 'pageModel',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchModel.request, state => {
      state.error = null;
      state.loading = true;
      state.loaded = false;
      state.model = null;
      state.customerId = null;
    });
    builder.addCase(fetchModel.success, (state, { payload }) => {
      state.model = payload;
      state.loaded = true;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchModel.failure, (state, { payload }) => {
      state.error = payload;
      state.model = null;
      state.loaded = true;
      state.loading = false;
      state.customerId = null;
    });
    builder.addCase(fetchModel.cancel, state => {
      state.error = null;
      state.model = null;
      state.loading = false;
      state.loaded = false;
      state.customerId = null;
    });
  },
});

export default pageModelSlice.reducer;
